import { useMutation, useQueryClient } from "@tanstack/react-query"
import type {
  DynamicDropdown,
  DynamicDropdownFormValues,
} from "../models/dynamicDropdown"
import { dynamicDropdownApi } from "../services/dynamicDropdownApi"

const BASE_KEY = "dynamic-dropdowns"

export function useCreateDynamicDropdown() {
  const queryClient = useQueryClient()
  return useMutation<DynamicDropdown, Error, DynamicDropdownFormValues>({
    mutationFn: (values) =>
      dynamicDropdownApi.create(values) as Promise<DynamicDropdown>,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BASE_KEY] })
    },
  })
}

export function useUpdateDynamicDropdown() {
  const queryClient = useQueryClient()
  return useMutation<
    DynamicDropdown,
    Error,
    { id: number; values: Partial<DynamicDropdownFormValues> }
  >({
    mutationFn: ({ id, values }) =>
      dynamicDropdownApi.update(id, values) as Promise<DynamicDropdown>,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BASE_KEY] })
    },
  })
}

export function useDeleteDynamicDropdown() {
  const queryClient = useQueryClient()
  return useMutation<void, Error, number>({
    mutationFn: (id) => dynamicDropdownApi.delete(id) as Promise<void>,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [BASE_KEY] })
    },
  })
}
